// Block quantity editing on the rebuy Smart cart. 

function blockSSQtyEditOnRebuyCart() {
  // Select all items in the cart drawer
  const items = document.querySelectorAll('.rebuy-cart__flyout-item-info');

  items.forEach(item => {
    // Find the delivery frequency element within the current item
    const deliveryFrequency = item.querySelector('.rebuy-cart__flyout-item-property--delivery-frequency');
    
    // Find the quantity widget buttons within the current item
    const quantityButtons = item.querySelectorAll('.rebuy-cart__flyout-item-quantity-widget-button');

    // Find the quantity widget label within the current item
    const quantityLabel = item.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');

    // Check if the delivery frequency element is not empty
    if (deliveryFrequency && deliveryFrequency.textContent.trim() !== '') {
      // Hide the quantity buttons
      quantityButtons.forEach(button => {
          button.style.display = 'none';
      });
      
      // Add the .no-border class to the quantity label
      if (quantityLabel) {
        quantityLabel.classList.add('no-border');
      }
    }
  });
}

function waitForElm(selector) {
  return new Promise(resolve => {if (document.querySelector(selector)) {return resolve(document.querySelector(selector));}const observer = new MutationObserver(mutations => {if (document.querySelector(selector)) {resolve(document.querySelector(selector));observer.disconnect();}});observer.observe(document.body, {childList: true,subtree: true});});
}


// Event listener - rebuy smart cart SHOW function
document.addEventListener('rebuy:smartcart.show', (event) => {
  blockSSQtyEditOnRebuyCart();// Call the function to apply the logic
});

document.addEventListener('rebuy:cart.add', (event) => { 
  console.log('rebuy:cart.add event CUSTOM', event.detail); 
    let item = event.detail.item
    let isAddedFromWidget = (item.properties && item.properties._attribution == "Rebuy Cart") || (item.items && item.items[0].properties._attribution == "Rebuy Cart") ? true : false;
    let isSubscription = event.detail.item.selling_plan_allocation ? true : false;
    console.log(' ???????? isAddedFromWidget ------> ', isAddedFromWidget, item.product_title, isSubscription); 
    // When the item is added from the recommanded widget, item object doesn't contain 'items' object. It's different with the adding product from quantity wrapper
    if (isAddedFromWidget && !isSubscription){
      window.Rebuy.Cart.changeItem({
        id: item.key,
        quantity: 1
      });
    }
    
});